import React, { ComponentProps } from 'react';

import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

import { LUX_LOYALTY_PROGRAM_CONFIG } from '@luxuryescapes/lib-lux-loyalty';

import { getLuxLoyaltyTierDisplayName } from '~/utils/luxLoyalty';

const TierChip = styled(Chip)(({ theme }) => ({
  '&.tier-bronze': {
    background: theme.palette.loyaltyTiers.bronze.gradient,
    color: theme.palette.loyaltyTiers.bronze.contrastText,
  },
  '&.tier-silver': {
    background: theme.palette.loyaltyTiers.silver.gradient,
    color: theme.palette.loyaltyTiers.silver.contrastText,
  },
  '&.tier-gold': {
    background: theme.palette.loyaltyTiers.gold.gradient,
    color: theme.palette.loyaltyTiers.gold.contrastText,
  },
  '&.tier-platinum': {
    background: theme.palette.loyaltyTiers.platinum.gradient,
    color: theme.palette.loyaltyTiers.platinum.contrastText,
  },
  '&.tier-infinite': {
    background: theme.palette.loyaltyTiers.infinite.gradient,
    color: theme.palette.loyaltyTiers.infinite.contrastText,
  },
}));

type InheritedChipProps = Omit<ComponentProps<typeof Chip>, 'label' | 'className'>;

interface Props extends InheritedChipProps {
  luxLoyaltyAccount: App.LuxLoyaltyAccount;
}

function LuxLoyaltyAccountChip({ luxLoyaltyAccount, ...chipProps }: Props) {
  return (
    <TierChip
      {...chipProps}
      label={
        <>
          {LUX_LOYALTY_PROGRAM_CONFIG.programDisplayName}{' '}
          <b>{getLuxLoyaltyTierDisplayName(luxLoyaltyAccount.tier)}</b> Member <b>#{luxLoyaltyAccount.accountNumber}</b>
        </>
      }
      className={`tier-${luxLoyaltyAccount.tier}`}
    />
  );
}

export default LuxLoyaltyAccountChip;
